"use client";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Icon } from "@/components/ui/icon";
import { SCOPE_OPTIONS } from "@/features/search/lib/filter-options";

export function ScopeDropdown({
  value,
  onChange,
}: {
  value: "c" | "p" | "cp";
  onChange: (v: "c" | "p" | "cp") => void;
}) {
  const current = SCOPE_OPTIONS.find((o) => o.value === value) ?? SCOPE_OPTIONS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="flex items-center gap-0.5 cursor-pointer">
          <span className="text-[11px] tracking-[-0.1px] text-ai whitespace-nowrap">
            {current.label}
          </span>
          <Icon name="IconChevronDownMedium" size={11} className="text-ai" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={2} className="w-[180px]">
        <DropdownMenuRadioGroup
          value={value}
          onValueChange={(v) => onChange(v as "c" | "p" | "cp")}
        >
          {SCOPE_OPTIONS.map((opt) => (
            <DropdownMenuRadioItem key={opt.value} value={opt.value}>
              <Icon name={opt.icon} size={14} className="text-foreground opacity-70" />
              <span>{opt.label}</span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
